module.exports = __webpack_public_path__ + "static/media/gebauer_weiss.3ce35162.gif";